import Hero from '../components/Hero';
import Stats from '../components/Stats';
import About from '../components/About';
import Products from '../components/Products';
import WhyUs from '../components/WhyUs';
import Projects from '../components/Projects';
import CTA from '../components/CTA';
import { useSeo } from '../hooks/useSeo';

const HomePage = () => {
  useSeo({
    title: '',
    description:
      'Membratek - 15 yillik tecrubeyle asma germe, membran yapi, celik konstruksiyon, depo cadiri ve gelgelendirme sistemleri. 500+ prestijli proje, ISO 9001 belgeli.',
    path: '/',
  });
  return (
    <main>
      <Hero />
      <Stats />
      <About />
      <Products />
      <WhyUs />
      <Projects />
      <CTA />
    </main>
  );
};

export default HomePage;
